<template>
  <div class="register-form">
    <div class="form-body">
      <div class="form-title">已有样衣，申请开店上架</div>
      <div class="form-desc">
        寄出你的原创样衣，参赛拿奖金，平台专属流量倾斜，同步免费开店上架优先曝光引流+变现！
      </div>
      <div class="form-desc-red" v-if="form_data.reason && form_data.status == 1">
        驳回原因：{{ form_data.reason }}
      </div>
      <div class="form">
        <div class="form-item-col-1">
          <div class="form-item-title required">填写款式样衣信息</div>
        </div>
        <div class="form-item-col-2">
          <div class="form-item-input">
            <div class="form-item-label">款号:</div>
            <div class="form-item-value">
              <input
                type="text"
                v-model="form_data.style_no"
                placeholder="请输入自定义样衣款号(如:YC20260501)"
              />
            </div>
          </div>
          <div class="form-item-input">
            <div class="form-item-label">款式名称：</div>
            <div class="form-item-value">
              <input
                type="text"
                v-model="form_data.style_name"
                placeholder="请输入款式名称(如:2026夏季桑蚕丝连衣裙)"
              />
            </div>
          </div>
        </div>
        <div class="form-item-col-1">
          <div class="form-item-input">
            <div class="form-item-label flex align-center">
              <span>上传样衣信息数据：</span>
              <div class="down-file-box">
                <a :href="setting.match_sample_template" class="download-link"
                  >样衣信息模板下载</a
                >
                <img src="../../assets/images/icon-down-file.png" />
              </div>
            </div>
            <div class="tips">
              请先下载样衣信息专用模板，按照填写规范完整录入样衣相关资料。请尽量详实、准确填写各项内容，有助于快速通过平台审核。
            </div>

            <div
              class="upload-file-item"
              v-for="(item, index) in form_data.apply_file"
              :key="index"
            >
              <a class="flex align-center" :href="item.raw" target="_blank"  :title="item.raw_name" style="width: 85%">
                <img
                  :src="util.get_image_icon(item.raw_name)"
                  class="icon-doc"
                />
                <span class="margin-left-10 text-333">{{ item.raw_name }}</span>
              </a>
              <img
                src="../../assets/images/icon-delete-creations.png"
                class="icon-delete"
                @click.stop="onDeleteFile(index)"

              />
            </div>

            <Upload
              action="/"
              :before-upload="(file) => onBeforeUpload(file)"
              :data="{ dir: 'template' }"
            >
              <div class="upload-file">+上传模板文件</div>
            </Upload>
          </div>
        </div>
        <div class="form-item-col-1">
          <div class="form-item-title required">寄出样衣</div>
        </div>
        <div class="address-box">
          <span class="address-tag">样衣收件地址:</span>
          <div class="address-text">
            {{ setting.contact_person }} {{ setting.contact_mobile }}
            {{ setting.contact_address }}
          </div>
          <span class="address-copy" @click="copyAddress()">复制</span>
        </div>
        <div class="form-item-col-2">
          <div class="form-item-input">
            <div class="form-item-label">物流公司:</div>
            <div class="form-item-value">
             <select
              class="form-input margin-left-5"
              placeholder="请选择物流公司"
              v-model="form_data.logistics_name"
            >
              <option value="">请选择</option>
              <option
                v-for="(item, index) in logistics"
                :key="index"
                :value="item"
              >
                {{ item }}
              </option>
            </select>
            </div>
          </div>
          <div class="form-item-input">
            <div class="form-item-label">物流单号:</div>
            <div class="form-item-value">
              <input
                type="text"
                v-model="form_data.logistics_no"
                placeholder="请输入快递单号"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="form-submit" v-if="form_data.status != 2">
        <div
          :class="['submit-btn', { disabled: !submitDisabled }]"
          @click="onSubmit"
        >
          提交申请
        </div>
        
      </div>
    </div>
  </div>
</template>
<script>
import {
 ApplyMatchSample,
 CheckApplyMatchSample
} from "@/api/social";
import Popup from "@/components/Popup";
import { uploadFileToOSS } from "@/utils/oss";
import region from "@/utils/region.js";
import util from "@/utils/util";
import { mapState } from "vuex";
import logistics from "@/utils/logistics";
export default {
  components: {
    Popup,
  },
  data() {
    return {
      util,
      form_data: {
        style_no: "",
        style_name: '',
        logistics_name: "",
        logistics_no: "",
        match_uuid:'',
        apply_file: [],
        status:0
      },
      logistics,
    };
  },
  watch: {
    
  },
  computed: {
    ...mapState({
      setting: (state) => state.setting,
      userInfo: (state) => state.userInfo,
    }),

    submitDisabled() {
      return (
        this.form_data.style_no &&
        this.form_data.style_name &&
        this.form_data.apply_file.length > 0
      );
    },
  },
  mounted() {
    let { uuid } = this.$route.query;
    this.form_data.match_uuid = uuid;
    this.getCheckInfo()
  },
  methods: {
    async getCheckInfo() {
      try {
        const { code, data } = await CheckApplyMatchSample({
            match_uuid:this.form_data.match_uuid
        });
        if(data){
            this.form_data = data;
        }
      } catch (e) {
        console.log("err", e);
      }
    },
    
    
     async copyAddress() {
      let text =
        this.setting.contact_person +
        " " +
        this.setting.contact_mobile +
        " " +
        this.setting.contact_address;
      await navigator.clipboard.writeText(text);
      this.$layer.msg("复制成功");
    },

    onDeleteFile(index) {
      this.form_data.apply_file.splice(index, 1);
    },
    async onBeforeUpload(file, field) {
      const url = await uploadFileToOSS(file, "template");
      this.form_data.apply_file.push({ raw: url, raw_name: file.name });
      return false;
    },
    async onSubmit() {
      try {
        console.log("form_data", this.form_data);
        
        if (!this.submitDisabled) {
          this.$layer.msg("请填写完整信息");
          return;
        }
        const { code, msg } = await ApplyMatchSample(this.form_data);
        if (code > 0) {
          this.$layer.msg(msg);
          return;
        }
        this.$layer.msg("申请成功");
        this.$router.back();
      } catch (e) {
        console.log("err-apply-pm", e);
        this.$layer.msg(e.msg);
      }
    },
    
  },
};
</script>
<style lang="scss" scoped>
.register-form {
  width: 100%;
  min-height: 100vh;
  background: #f5f9fc;
  display: flex;
  justify-content: center;
  padding-bottom: 80px;
  user-select: none;
  .form-body {
    width: 100%;
    max-width: 1000px;
    margin-top: 28px;
    background: #fff;
    border-radius: 10px;
    box-shadow: 0px 0px 8px 4px rgba(1, 32, 55, 0.05);
    .form-title {
      width: 100%;
      text-align: center;
      color: #333;
      font-weight: bold;
      font-size: 28px;
      margin-top: 30px;
    }
    .form-desc {
      margin-top: 8px;
      text-align: center;
      width: 100%;
      color: #666;
      font-size: 14px;
      padding-bottom: 24px;
      border-bottom: 1px solid #ebebeb;
    }
    .form-desc-red{
      margin-top: 20px;
      text-align: center;
      width: 100%;
      color: red;
      font-size: 14px;
      padding-bottom: 20px;
      border-bottom: 1px solid #ebebeb;
    }
    .form {
      width: 100%;
      padding: 0 50px;
      margin-top: 28px;
      .form-item-input {
        flex: 1;
        display: flex;
        flex-direction: column;
        row-gap: 7px;
        margin-bottom: 32px;
        .tips {
          font-weight: 400;
          font-size: 13px;
          color: #666666;
          margin-bottom: 10px;
        }
        .upload-file-item {
          width: 444px;
          height: 52px;
          background: #f6f7f9;
          border-radius: 4px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 12px;
          .icon-doc {
            width: 36px;
            height: 36px;
          }
          .icon-delete {
            width: 16px;
            height: 16px;
          }
        }
        .upload-file {
          width: 160px;
          height: 40px;
          line-height: 40px;
          background: #ffffff;
          border-radius: 4px 4px 4px 4px;
          border: 1px solid #fa3d5b;
          text-align: center;
          color: #fa3d5b;
          cursor: pointer;
          margin-top: 10px;
        }
        .form-item-label {
          color: #333;
          font-size: 16px;
          &.required::after {
            content: "*";
            color: red;
          }
          .down-file-box {
            display: flex;
            align-items: center;
            .download-link {
              font-family: Source Han Sans CN, Source Han Sans CN;
              font-weight: 400;
              font-size: 14px;
              color: #0088ff;
            }
            img {
              width: 20px;
              height: 20px;
            }
          }
        }
        .form-item-label-with-remark {
          color: #333;
          font-size: 14px;
          display: flex;
          align-items: center;
          column-gap: 5px;
          .required::after {
            content: "*";
            color: red;
          }
          .remark {
            color: #666;
          }
        }
        .file-box {
          display: flex;
          flex-wrap: wrap;
          column-gap: 10px;
          margin-top: 16px;
          .file-item {
            width: 172px;
            height: 116px;
            border-radius: 4px 4px 4px 4px;
            border: 1px solid #e3e3e3;
            display: flex;
            align-content: center;
            position: relative;
            .img {
              height: 116rpx;
            }
            .remove-icon {
              width: 22px;
              height: 22px;
              position: absolute;
              top: 5px;
              right: 5px;
            }
          }
        }
        .form-item-upload {
          width: 100%;
          height: 150px;
          background: #f8f9fb;
          border-radius: 10px 10px 10px 10px;
          border: 1px solid #b3b3b3;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          .upload-ico {
            width: 24px;
            height: 24px;
          }
        }
        .form-item-value {
          width: 100%;
          height: 50px;
          border: 1px solid #e3e3e3;
          border-radius: 8px;
          overflow: hidden;
          padding: 0 16px;
          input,
          textarea,
          select {
            border: none;
            outline: none;
            width: 100%;
            height: 100%;
            &:focus {
              border: none;
              border-color: transparent !important;
            }
          }
          ::v-deep .ivu-select-selection {
            height: 100%;
            display: flex;
            align-items: center;
            border: none;
          }
          ::v-deep .ivu-select-placeholder {
            color: #999;
          }
          ::v-deep .ivu-cascader-rel {
            height: 100%;
            border: none;
            outline: none;
            display: flex;
            align-items: center;
          }
          ::v-deep .ivu-cascader {
            height: 100%;
            display: flex;
            align-items: center;
            border: none;
          }
          ::v-deep .ivu-input {
            border: none;
            outline: none;
            height: 100%;
            &:focus {
              border-color: transparent !important;
              box-shadow: none !important;
              -webkit-box-shadow: none !important;
            }
          }
        }
        .form-item-value-upload {
          width: 100%;
          display: flex;
          align-items: center;
          column-gap: 16px;
          .upload-item {
            width: 260px;
            display: flex;
            flex-direction: column;
            align-items: center;
            row-gap: 12px;
            cursor: pointer;
            .img-item {
              width: 100%;
              height: 176px;
              // border-radius:10px;
              border: 1px dashed #e3e3e3;
              overflow: hidden;
              position: relative;
              .delete-ico {
                position: absolute;
                top: 4px;
                right: 4px;
                width: 20px;
                height: 20px;
                cursor: pointer;
              }
              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                object-position: center;
                border-radius: 10px;
              }
            }
            .item-title {
              color: #999;
              font-size: 12px;
            }
          }
          ul li {
            color: #999;
            font-size: 12px;
            margin-left: 22px;
          }
        }
        .form-item-value-checkbox {
          display: flex;
          flex-wrap: wrap;
          gap: 12px;
          .checkbox-item {
            width: 140px;
            height: 42px;
            border: 1px solid #e3e3e3;
            border-radius: 4px;
            display: flex;
            align-items: center;
            padding-left: 16px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            ::v-deep .ivu-checkbox-checked .ivu-checkbox-inner {
              border-color: #ff5967;
              background-color: #ff5967;
            }
          }
        }
        .form-item-value-radio {
          display: flex;
          align-items: center;
          .radio-item {
            width: 100px;
            height: 42px;
            display: flex;
            align-items: center;
            justify-content: center;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }
    .form-agree {
      display: flex;
      align-items: center;
      column-gap: 5px;
      color: #666;
      font-size: 14px;
      padding-left: 50px;
      margin-top: 35px;
      div {
        cursor: pointer;
      }
    }
    .form-submit {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 57px;
      margin-bottom: 60px;
      .submit-btn {
        width: 220px;
        height: 48px;
        border-radius: 8px;
        background: #ff5967;
        color: #fff;
        cursor: pointer;
        font-size: 16px;
        text-align: center;
        line-height: 48px;
        &.disabled {
          background: rgba(255, 89, 103, 0.5);
          cursor: not-allowed;
        }
      }
    }
  }
}
.form-item-col-2 {
  display: flex;
  align-items: center;
  column-gap: 20px;
}
.form-item-col-1 {
  width: 100%;
  display: flex;
  align-items: center;
}

.form-item-title {
  color: #000;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 16px;
  &.required::after {
    content: "*";
    color: red;
  }
}
.form-item-col-half {
  width: 50%;
  display: flex;
  align-items: center;
}
.address-box {
  display: flex;
  align-items: center;
  background-color: #f6f7f9;
  padding: 15px 17px;
  border-radius: 10px;
  margin-bottom: 32px;

  .address-tag {
    background-color: #0066ff;
    color: #fff;
    font-size: 12px;
    padding: 2px 8px;
    border-radius: 4px;
    margin-right: 10px;
  }

  .address-text {
    flex: 1;
    color: #333;
    font-size: 14px;
  }

  .address-copy {
    color: #0066ff;
    font-size: 12px;
    cursor: pointer;
  }
}

::v-deep .ivu-radio-checked .ivu-radio-inner {
  border-color: rgb(255, 89, 103);
}

::v-deep .ivu-radio-focus {
  -webkit-box-shadow: 0 0 0 2px rgba(255, 89, 103, 0.2);
  box-shadow: 0 0 0 2px rgba(255, 89, 103, 0.2);
  z-index: 1;
}

::v-deep .ivu-radio-inner:after {
  background-color: #ff5967;
}

::v-deep .popup-modal {
  /* 弹窗内容区 */
  .popup-content {
    /* 修正后 */
    width: max(980px, 96vw); // 增加视口占比
    min-width: 320px; // 保障最小可操作宽度
    max-width: none !important; // 移除潜在限制

    /* 添加边距保护 */
    margin: 0 2vw; // 左右留白
    box-sizing: content-box; // 防止padding影响
    max-height: max(500px, 80vh); // 最大720px，最小占85%视口高
    min-height: 30vh;
    // height:100%;
    display: flex;
    flex-direction: column;
    .agree-content {
      overflow-y: scroll;
      height: 100%;
      max-height: max(30vh, 70vh); // 最大720px，最小占85%视口高
      padding: 30px 30px 0 30px;
      &::-webkit-scrollbar {
        width: 0px;
        background: transparent;
      }

      &::-webkit-scrollbar-thumb {
        background: #ddd;
        border-radius: 3px;
      }
    }
  }
}
</style>
